<template>
  <div class>
    <div class="choose-box tab-box top-tab-box">
      <div class="clearFix" v-for="(item,index) in condition" :key="item.id">
        <div class="floatl">{{item.name}}</div>
        <div class="floatl">
          <el-tabs class="tab-item floatl" v-model="classificName" :data-item="item" @tab-click="clickitem">
            <el-tab-pane :label="item.name" :name="`${item.id}`" v-for="item in item.children" :key="item.id" ></el-tab-pane>
          </el-tabs>
        
        </div>
      </div>
    </div>
    <div class="tab-box center-tab-box clearFix">
      <span class="floatl">品牌筛选</span>
      <el-tabs class="tab-item floatl" v-model="activeBrand" @tab-click="handleClick">
        <el-tab-pane class="noLimit" label="不限" name="0" key="0"></el-tab-pane>
        <el-tab-pane :label="item.name" :name="item.name" v-for="item in brand" :key="item.id"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="product-list clearFix">
      <div class="empty-box" v-if="showTable.total == 0">暂无此类商品</div>
      <a v-else v-for="item in showTableList" :key="item.id">
        <div class="product-img-box">
          <img
            v-if="!item.productListImg && !item.brandUrl"
            src="http://39.107.228.160:9000/static/img/cytech_logo.73361c2.png"
            @click="Jump(item.id)"
            alt="商品图"
          >
          <img v-else-if=" !item.productListImg &&item.brandUrl" :src="`${$base.urlImage}${item.brandUrl}`" @click="Jump(item.id)" alt="商品图">
          <img v-else-if="item.productListImg" :src="item.productListImg" @click="Jump(item.id)" alt="商品图">
         
        </div>
        <div class="product-msg-box">
          <p  :title="item.productName">名称：{{item.productName}} </p> 
          <div>品牌：{{item.brandName}}</div>
          <div>订货号：{{item.orderNo}}</div>
          <div v-if="item.isPay == null || item.isPay == 0">报价：{{item.pymoney}}</div>
          <div v-else-if="item.isPay != null || item.isPay != 0">报价：询价</div>
          <div>规格：{{item.specifications}}</div>
          <img @click.stop="enterShopCart(item)" src="./../../../assets/shop.png" alt>
        </div>
      </a>
    </div>
    <div class="paging">
      <el-pagination
        :page-size="8"
        :pager-count="11"
        :next-text="newsNext"
        :prev-text="newsPrev"
        layout="prev, pager, next"
        :total="showTable.total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { post, get, postRequest } from "@/axios/index";
export default {
  data() {
    return {
      //分类名
      classificName: 0,
      //头部筛选条件
      condition: [],
      // 品牌tab默认选中值
      activeBrand: "0", // 默认不限
      brand: [],
      showTableList: [],
      showTable: {
        pageSize: 0
      },
      newsNext: "下一页 >",
      newsPrev: "< 上一页",
      userId: 0,
      productName: "", //顶部所有，按产品名搜索
      appIdFuzzy: "", //应用分类
      basicImg: "", //商品类别图片
      description: "" //商品类别描述
    };
  },
  computed: {},

  methods: {
    //勾选筛选条件
    // elRadioChange(data) {
    //   console.log('89',data.name);
    //   // console.log('94', value)
    // },
    elChangeBrand(value) {
      console.log(value)
    },
    clickitem(data) {
      this.activeBrand = "0";
      let e = data.name;
      console.log(e, "e====================");
      this.classificName = data.name;
      console.log("555555555555==========")
      this.getDefault(null, this.classificName, this.activeBrand);
    },
    Jump(id) {
      let goodsId = id;
      // 跳转
      this.$router.push({
        path: "/pc/product-detail",
        query: {
          id: goodsId
        }
      });
    },
    //选择品牌
    handleClick(tab, event) {
      console.log(
        "tab.index=0,代表不限.品牌筛选===不限",
        tab.index,
        "index",
        tab.label,
        "label"
      );
      if (tab.index == 0) {
        this.activeBrand = "0";
        console.log("111111111111==========")
        this.getDefault(null, this.classificName, this.activeBrand);
      } else {
        this.activeBrand = tab.label;
        if(this.classificName == 0){
          this.classificName = null;
        }
        console.log("22222222222==========",this.classificName,this.activeBrand)
        this.getDefault(null, this.classificName, this.activeBrand);
      }
    },
    getDefault(index, dId, bName, productName) {
      //页码, typeId选中id, 选中商品名称
      if (!dId) {
        //没有选择耗材或者仪器、试剂分类
        dId = null;
      }
      if (!bName || bName == 0) {
        //没有选择品牌
        bName = null;
      }
      if (!this.productName) {
        //没有选择耗材或者仪器、试剂分类
        productName = null;
      }
      console.log(bName);
      console.log(productName);
      productName = this.productName;
      get("/stkproductinfo/getlistbystatusandtype", {
        page: index, //页数
        typeId: dId, //产品分类
        brandName: bName, //品牌名
        productNameFuzzy: productName //产品名字
      })
        .then(res => {
          console.log("默认请求查看商品数据res=", res.data.result);
          this.showTableList = res.data.result.pageData;
          this.showTable = res.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
      console.log("1==========" + dId);
      if (productName && dId) {
        //产品模糊搜索查询品牌
        get("/stkproductinfo/getlistbyproductnamefuzzy", {
          productNameFuzzy: productName //产品模糊搜索
        }).then(res => {
          console.log("搜索品牌", res.data.result);
          this.brand = res.data.result.map(item => {
            return {
              name: item.brandName,
              id: item.brandId
            };
          });
        });
      } else if (productName) {
        //产品模糊搜索查询品牌
        get("/stkproductinfo/getlistbyproductnamefuzzy", {
          productNameFuzzy: productName //产品模糊搜索
        }).then(res => {
          console.log("搜索品牌", res.data.result);
          this.brand = res.data.result.map(item => {
            return {
              name: item.brandName,
              id: item.brandId
            };
          });
        });
      } else if (!dId) {
         console.log('207无',dId)
        get("/stkproductinfo/getlistbrand", {
          typeId: dId //产品分类
        }).then(res => {
          console.log("搜索品牌", res.data.result);
          this.brand = res.data.result;
        });
      } else if (dId) {
        console.log('215有',dId)
        get("/stkproductinfo/getlistbrand", {
          typeId: dId //产品分类
        }).then(res => {
          console.log("搜索品牌", res.data.result);
          this.brand = res.data.result;
        });
      } 
      
    },
    handleCurrentChange(val) {
      // console.log("根据分页大小修改产品页,显示下标=", val);
      this.showTable.pages = val;
      this.getDefault(
        this.showTable.pages,
        this.classificName,
        this.activeBrand,
        this.productName
      );
    },
    enterShopCart(items) {
      if (this.userId) {
        //判断用户是否已登录
        postRequest("/stkshoppingcenterinfo/insertstkshoppingcenterinfo", {
          productId: items.id,
          userRegisterId: this.userId,
          productNumber: 1
        }).then(res => {
            console.log('添加结果res=', res.data.msg)
            if(res.data.code == '201'){
              this.$message({
                  type: "error",
                  message: res.data.msg
                });
            }
            if(res.data.code == '200'){
              this.$confirm("商品已成功加入购物车", "提示", {
                confirmButtonText: "继续购物",
                cancelButtonText: "查看购物车",
                type: "success",
                center: true
              })
                .then(() => {
                  console.log('点击继续购物')
                })
                .catch(() => {
                  console.log('点击查看购物车')
                  this.$router.push({
                    path: "/pc/order-cart"
                  });
                });
            }
          })
          .catch(err => {
            console.log('261',err);
            this.$message({
              type: "error",
              message: err.message
            });
            console.log("添加失败err=", err);
          });
      } else {
        //没有登录
        this.$router.push({
          path: "/login"
        });
      }
    }
  },
  mounted() {
    if (this.$route.query.productName) {
      this.productName = this.$route.query.productName;
    }
    if (this.$route.query.proTypeFuzzyId) {
      //按产品分类筛选
      this.classificName = this.$route.query.proTypeFuzzyId;
    }
    //获取筛选条件
    get("/stkbasicdict/getlistbystatus", {}).then(
      response => {
        this.condition = response.data.result;
        console.log(this.condition, "showTableList,查询条件");
      },
    );
    get("/stkproductinfo/getlistbrand").then(res => {
      this.brand = res.data.result;
    });
    //获取默认商品
    if (this.$route.query.appTypeFuzzyId) {
      //按应用分类筛选
      this.appIdFuzzy = this.$route.query.appTypeFuzzyId;
      get("/stkproductinfo/getlistbystatusandapplicationId", {
        applicationId: this.appIdFuzzy
      })
        .then(res => {
          this.showTableList = res.data.result.pageData;
          this.showTable = res.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    } else {
      console.log("333333333333==========")
      //其他筛选
      this.getDefault(null, this.classificName, 0, this.productName);
    }
  },
  created() {
    //获取用户id
    if (JSON.parse(localStorage.getItem("stkMessage"))) {
      this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
    }
  },
  watch: {
    $route(to, from) {
      console.log('337',this.$route.query.productName)
      // console.log('338',to)
      this.productName = this.$route.query.productName;
      this.getDefault(null, null, 0, this.productName);
      console.log("44444444444==========")
    }
  }
};
</script>

<style lang="less" scoped>
.product-img-box {
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
    max-height: 200px;
  }
}

.product-list {
  .common-content-width();
  .common-shadow();
  margin-bottom: 50px;
  > a:nth-of-type(4n) {
    margin-right: 0;
  }
  a {
    .product-msg-box {
      position: relative;
      img {
        width: 44px;
        height: 44px;
        position: absolute;
        right: 0px;
        bottom: 10px;
        padding: 10px;
        cursor: pointer;
      }
      p {
        height: 24px;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden !important;
        width: 100%;
        white-space: nowrap;
      }
    }
  }
}

.tab-box {
  .common-shadow();
  padding: 10px 20px;
  > span:first-child {
    color: #333;
    height: 30px;
    line-height: 30px;
    padding-right: 50px;
  }
}

/deep/.center-tab-box {
  margin-bottom: 20px;
  .el-tabs__item {
    color: #666;
  }
  .el-tabs__item.is-active {
    color: #409eff;
  }
}

.tab-item {
  width: 840px;
}

/deep/.top-tab-box {
  margin-bottom: 20px;
  margin-top: 30px;
  line-height: 40px;
  .el-radio-group {
    float: left;
  }
  .el-radio__label {
    color: #999;
    padding-left: 0;
  }
  .clearFix > .floatl:first-child {
    margin-right: 50px;
  }
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #409eff !important;
}

/deep/.el-checkbox-button__inner {
  border: 0;
  border-bottom: 2px solid transparent !important;
  border-radius: 0 !important;
  margin-right: 50px;
}

/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: transparent;
  border: 0;
  color: @common-blue !important;
  border-bottom: 2px solid @common-blue !important;
  box-shadow: none;
}

/deep/.el-checkbox-button:first-child .el-checkbox-button__inner {
  border-left: 0;
}

/deep/.el-checkbox-button:last-child .el-checkbox-button__inner {
  border-right: 0;
}

/deep/.el-radio-group {
  vertical-align: middle;
}

.is-checked {
  background: transparent;
  border: 0;
  color: @common-blue !important;
  border-bottom: 2px solid @common-blue !important;
  box-shadow: none;
}

.el-radio {
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 5px 20px;
}

/deep/.el-radio__input {
  display: none;
}

.paging {
  height: 40px;
  line-height: 40px;
  // color: #a5a5a5;
  font-size: 28px;
  margin: 49px 0 48px;
  text-align: center;
  position: relative;
}

/deep/.el-pager li.active {
  background-color: #409eff;
  color: #fff;
}
.floatl001 {
  img {
    width: 185px;
    height: 185px;
    margin-left: 101px;
    margin-top: 20px;
  }
}
.floatl01{
  height: 210px;
  .floatl001{
    float: left;
  }
  .floatl002{
    float: left;
    margin-top: 20px;
    width: 40%;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/goods/Product.vue